import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { pushEvent, resolveEvent } from '../../../utils/analytics/datalayer';

const pattern = new RegExp(/(?<={)([a-zA-Z0-9\.][^}]+)/g);

const DatalayerPush = ({ fields, state }) => {
  useEffect(() => {
    const event = resolveEvent(fields.event?.value, state);
    pushEvent(event);
  }, []);

  return <></>;
};

const mapStateToProps = (state, props) => {
  return {
    ...props,
    state,
  };
};
export default connect(mapStateToProps)(DatalayerPush);
